import React from 'react'
import "./style.css";
import { HomeCategory } from '../../../../types/homeCategoryType';
export const ShopByCategoryCard = ({item,handleClick}:{item:HomeCategory,handleClick: (categoryId: string, pageNumber: number) => Promise<void>}) => {
  return (
    <button onClick={() => {!!item.categoryId && handleClick(item.categoryId,0) }} className='flex gap-6 flex-col items-center group cursor-pointer'>
        <div className="custom-border rounded-full lg:w-[249px] lg:h-[249px] w-[150px] h-[150px] bg-[rgb(211,211,211)]">
            <img className='w-full h-full overflow-hidden rounded-full group-hover:scale-95 transition-transform transform-duration-700 object-cover object-top' src={item.image} alt="not found" />
        </div>
        <h1>{item.name}</h1>
    </button>
  )
}
